<template>
	<div class="about-page">
		<Header />
		<div class="about-content">
			<img :src="aboutImage1" class="about-image" alt="关于我们" />
			<img :src="aboutImage2" class="about-image2" alt="关于我们" />
			<img :src="aboutImage3" class="about-image" alt="关于我们" />
		</div>
		<Footer />
	</div>
</template>

<script setup>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import aboutImage1 from '@/assets/about1.png'
	import aboutImage2 from '@/assets/about2.png'
	import aboutImage3 from '@/assets/about3.png'
</script>

<style scoped>
	.about-page {
		background: #fff;
	}

	.about-image2 {
		max-width: 1400px;
		margin: auto;
		display: block;
	}

	.about-image {
		width: 100%;
		display: block;
	}
</style>